$(document).on('shopify:section:load', function() {
    if ($('.affiliate-program').length) {
        $('.affiliate-program .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function randomNumberWithZeros(digits) {
                return "0".repeat(digits);
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberAF() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithZeros(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
                let random4 = randomNumberWithDigits(digitCount);
                let random5 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${random4}</span>
                    <span>${random5}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberAF() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 300);
            }
        
            $this.data('randomNumberAF', randomNumberAF);
            $this.data('animateNumberAF', animateNumberAF);
        
            randomNumberAF();
            animateNumberAF();
        });
    }

    affiliate_banner();
    affiliate_program();
    earn_commission();
    affiliate_details();
});

$(document).ready(function() {
    if ($('.affiliate-program').length) {
        $('.affiliate-program .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function randomNumberWithZeros(digits) {
                return "0".repeat(digits);
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberAF() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithZeros(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
                let random4 = randomNumberWithDigits(digitCount);
                let random5 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${random4}</span>
                    <span>${random5}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberAF() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 300);
            }
        
            $this.data('randomNumberAF', randomNumberAF);
            $this.data('animateNumberAF', animateNumberAF);
        
            randomNumberAF();
            animateNumberAF();
        });
    }

    affiliate_banner();
    affiliate_program();
    earn_commission();
    affiliate_details();
});

$(window).scroll(function() {

    affiliate_banner();
    affiliate_program();
    earn_commission();
    affiliate_details();

});

function affiliate_banner() {
    if ($('.affiliate.page-banner').length) {
        $('.affiliate.page-banner').each(function() {
            let el = $(this);

            if (visiblePercent(el) > 50) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });
    }
}

function affiliate_program() {
    if ($('.affiliate-program').length) {
        $('.affiliate-program').each(function() {
            let el = $(this);
        
            if (wSize >= 1280) {
                if (visiblePercent(el) > 90) {
                    el.find('.count span').each(function () {
                        let $this = $(this);
                        if (!$this.data('hasAnimated') && $this.data('randomNumberAF') && $this.data('animateNumberAF')) {
                            $this.data('randomNumberAF')();
                            $this.data('animateNumberAF')();
                            $this.data('hasAnimated', true);
                        }
                    });
                }
            }
            else {
                if (visiblePercent(el) > 30) {
                    el.find('.count span').each(function () {
                        let $this = $(this);
                        if (!$this.data('hasAnimated') && $this.data('randomNumberAF') && $this.data('animateNumberAF')) {
                            $this.data('randomNumberAF')();
                            $this.data('animateNumberAF')();
                            $this.data('hasAnimated', true);
                        }
                    });
                }
            }
        });    
    }
}

function earn_commission() {
    if ($('.earn-commission').length) {
        $('.earn-commission').each(function() {
            let el = $(this);

            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });
    }
}

function affiliate_details() {
    if ($('.affiliate-details').length) {
        $('.affiliate-details').each(function() {
            let el = $(this);

            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });
    }
}